"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentMethodLayout_1 = require("./PaymentMethodLayout");
exports.default = PaymentMethodLayout_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/PaymentMethodLayout/index.js
// module id = 38
// module chunks = 0 1